import { NgModule } from '@angular/core';
import { MainRoutingModule } from './main-routing.module';
import { SharedModule } from '../shared/shared.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { LottieModule } from 'ngx-lottie';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

export function playerFactory() {
  return import('lottie-web');
}

@NgModule({
  declarations: [MainRoutingModule.components],
  imports: [
    MainRoutingModule,
    SharedModule,
    PerfectScrollbarModule,
    LottieModule.forRoot({ player: playerFactory }),
    LeafletModule,
    ShareButtonsModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
})
export class MainModule {}
